/**
 * Validation error messages for Bulk Upload (Checklist & Trial Balance)
 */

export const CHECKLIST_VALIDATION_MESSAGES = {
  DESCRIPTION_REQUIRED: 'Description is required',
  CATEGORY_REQUIRED: 'Category is required',
  SUBCATEGORY_REQUIRED: 'Subcategory is required',
  LOCATION_REQUIRED: 'At least one location is required',
  PREPARER_REQUIRED: 'At least one preparer is required',
  APPROVER_REQUIRED: 'At least one approver is required',
  TAGS_REQUIRED: 'At least one tag is required',
  PREPARER_APPROVER_OVERLAP: 'cannot be both preparer and approver',
  INACTIVE_PREPARER: 'Inactive preparer(s)',
  INACTIVE_APPROVER: 'Inactive approver(s)',
  INVALID_GL_CODE: 'Invalid GL Code(s)',
  INVALID_CATEGORY: 'Invalid Category. It must be from Chart of Accounts',
  INVALID_SUBCATEGORY: 'Invalid Sub Category. It must be from Chart of Accounts',
  INVALID_NUMBER: 'is not a valid number',
  INVALID_DATE: 'is not a valid date',
  INVALID_LOCATION: 'Invalid location(s)',
  DUE_DAYS_OUT_OF_RANGE: 'Due Days must be between -200 and 200'
};

export const TRIAL_BALANCE_VALIDATION_MESSAGES = {
  GL_CODE_REQUIRED: 'GL Code is required',
  GL_CODE_NOT_FOUND: 'GL Code not found in Chart of Accounts',
  DUPLICATE_ACCOUNT_EMPTY_LOCATION: 'Account No already exists with empty Location.'
};

export const GENERAL_ERROR_MESSAGES = {
  FAILED_LOAD_CHART_OF_ACCOUNTS: 'Failed to load Chart of Accounts for GL validation',
  FAILED_LOAD_LOCATIONS: 'Failed to load location list',
  EXTENSION_NOT_SUPPORTED: 'Only xlsx, xls, xlsm, xlsb file extensions supported',
  ERROR_READING_GLCODES: 'Error reading glcodes',
  ERROR_UPLOADING_CHECKLIST: 'Error uploading Tasklist',
  ERROR_UPLOADING_TB: 'Error uploading Trial Balance',
  UNKNOWN_ERROR: 'Unknown error!'
};

export const HEADER_ERROR_MESSAGES = {
  MISSING_COLUMN: (columnName, position) => `Missing column '${columnName}' at position ${position}`,
  WRONG_COLUMN: (expected, found, position) => `Expected '${expected}' at position ${position} but found '${found}'`,
  EXTRA_COLUMN: (columnName, position) => `Unexpected extra column '${columnName}' at position ${position}`,
  HEADER_MISMATCH: 'Column headers mismatch detected:',
  EXPECTED_HEADERS: (headers) => `Expected headers: '${headers.join("', '")}'`,
  FOUND_HEADERS: (headers) => `Found headers: '${headers.join("', '")}'`,
  ENSURE_ORDER: 'Please ensure columns are in the correct order.'
};
